<template>
  <div class="lib__form__main">
    <ValidationObserver ref="validator" slim tag="div" class="lib__form__main__content">
      <header class="lib__form__main__header">
        <h2 class="lib__h2">{{ $t('new-connection-cmh.address-step.topParagraph') }}</h2>
      </header>

      <zipCode-locality-selector :label="$t('new-connection-cmh.zipCodeOrLocality')" v-model="subCity"
        class="zipcode-margin" :inputClass="'lib__field__input'"
        :placeHolder="$t('new-connection-cmh.zipCodeOrLocality')"
        :unorderedListContainerClass="'autocomplete-suggestions'" :suggestionItemClass="'autocomplete-suggestion-item'"
        :suggestionItemTextClass="'autocomplete-suggestion-text'" />

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <street-sub-city-selector v-if="subCity" :label="$t('address.street')" :required="!addMapLocation"
                :sub-city-id="subCity.georesSubcityId" @validation="onStreetSubCityValidation"
                v-model="streetSubCity" />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <check-box v-if="subCity" :label="$t('address.nameOfTheStreetNotAssignedByTheMunicipality')"
                v-model="addMapLocation"></check-box>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <text-box v-if="subCity" :required="!addMapLocation" :label="$t('address.N°')" :max="8"
                v-model="houseNumber" :rules="{ house_number_valid_characters: true }"></text-box>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="margin-top:15px;">
              <a href="#" v-if="subCity" @click="openNonFinalNumberModal()" class="lib__link__mobile--underline">{{
                $t('address.nonFinalNumberQuestionMark') }}</a>
            </div>
          </div>
        </div>
      </div>

      <template>
        <div class="row" v-if="addMapLocation">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <map-location-picker :address="addressString" class="lib__no-margin" v-model="mapLocation" />
          </div>
        </div>
      </template>
      <connection-point-area check-for-elec check-for-gas hide-success-messages :showSynergridLink="false"
        :sub-city="subCity" @canAllowElecOrGas="hasOres = $event" />

      <div
        v-if="isSelectionStepDisplayed && statePackageFromSimulator === null && subCity && subCity.gridOperators && subCity.gridOperators.isInOresScope">
        <header class="lib__form__main__header">
          <h2 class="lib__h2">{{ $t('new-connection-cmh.address-step.middleParagraph') }}</h2>
        </header>
        <building-type-selector @selectionChanged="onSelectionChange"
          :stateSelection="stateAddressPoint && stateAddressPoint.selection ? stateAddressPoint.selection : ''" />
        <div v-if="isHouseSelected || isBuildingSelected">
          <div v-if="isBuildingSelected">
            <text-box :label="$t('new-connection-cmh.address-step.flatNumber')" v-model="flatNumber" onlyNumbers
              :min="1" :max="2" required />
            <text-box :label="$t('new-connection-cmh.address-step.commonElectricMeterNumber')"
              v-model="commonElectricMeterNumber" onlyNumbers :min="0" :max="3" required />
          </div>
          <img v-if="(isHouseSelected && subCity && subCity.connectMyHomeActivated) ||
            (flatNumber && commonElectricMeterNumber && subCity && subCity.connectMyHomeActivated)
          " :style="getCmhLogoStyle()" class="cmh-logo" :src="require('@/assets/cmh-logo.svg')" alt="Logo CMH" />
          <div v-if="isHouseSelected && subCity && subCity.connectMyHomeActivated">
            <h2 class="lib__h2 lib__text-center cmh-availability-top-paragraph">
              {{ $t('new-connection-cmh.serviceIsAvailable') }}
              <i @click="openBuildingInfoModal()"
                class="lib__text-secondary cmh-availability-top-paragraph-icon-info fa fa-info-circle"></i>
            </h2>
          </div>
          <div v-if="isBuildingSelected && flatNumber && commonElectricMeterNumber && subCity && subCity.connectMyHomeActivated">
            <h2 v-if="!hasBuildingCmhUnavailable" class="lib__h2 lib__text-center cmh-availability-top-paragraph">
              {{ $t('new-connection-cmh.serviceIsAvailable') }}
              <i @click="openBuildingInfoModal()"
                class="lib__text-secondary cmh-availability-top-paragraph-icon-info fa fa-info-circle"></i>
            </h2>
            <h2 v-if="hasBuildingCmhUnavailable" class="lib__h2 lib__text-center cmh-availability-top-paragraph">
              {{ $t('new-connection-cmh.address-step.serviceNotAvailableForMoreThanFourFlatBuilding') }}
            </h2>
            <p class="lib__text-center cmh-availability-middle-paragraph building-text"
              v-if="hasBuildingCmhUnavailable">
              {{ $t('new-connection-cmh.address-step.youCanContinueWithGasAndElectricity') }}
            </p>
          </div>
          <div v-if="areAvailableServiceDisplayed && subCity && subCity.connectMyHomeActivated">
            <p class="lib__text-center cmh-availability-middle-paragraph" v-html="isFullyAvailable
              ? $t('new-connection-cmh.iCanAskForThoseOperators')
              : $t('new-connection-cmh.youCanAskForThoseOperators')
              "></p>
            <available-service-display :subCity="subCity" />
          </div>
          <div v-if="areLinksDisplayed && subCity && subCity.connectMyHomeActivated">
            <p class="lib__text-center cmh-availability-bottom-paragraph">
              {{ $t('new-connection-cmh.someOperatorsNotAvailable') }}
            </p>
            <cmh-providers-external-links
              :isOrangeDisplayed="!(subCity && subCity.connectMyHomeInformation && subCity.connectMyHomeInformation.vooAvailable) || hasBuildingCmhUnavailable"
              :isProximusDisplayed="!(subCity && subCity.connectMyHomeInformation && subCity.connectMyHomeInformation.proximusAvailable) || hasBuildingCmhUnavailable"
              :isSwdeDisplayed="!(subCity && subCity.connectMyHomeInformation && subCity.connectMyHomeInformation.swdeAvailable) || hasBuildingCmhUnavailable" />
          </div>
        </div>
      </div>
      <div class="cmh-modal-layout">
        <div class="cmh-modal-layout building-info-modal">
          <ModalDialog :closeable="$t('common.close')" :open.sync="isNonFinalNumberModalOpen">
            <p class="lib__text-weight-200">
              {{ $t('address.nonFinalNumberModalMainMessage') }} <br>
              {{ $t('address.nonFinalNumberModalInstructionMessage') }}
            </p>
            <p class="lib__text-small">
              {{ $t('address.nonFinalNumberModalExampleMessage') }}
            </p>
          </ModalDialog>
          <ModalDialog :closeable="$t('common.close')" :open.sync="isBuildingInfoModalOpen">
            <cmh-modal-partners>
              <template #header>
                <p class="main-title-modal text top-paragraph">
                  {{ $t('new-connection-cmh.address-step.connectMyHomeIsAUniqueRequest') }}
                </p>
              </template>
              <template #content>
                <i18n class="main-title-modal text"
                  path="new-connection-cmh.address-step.oneInterlocutorThroughoutTheProcess" scope="global" tag="p">
                  <span class="lib__text-weight-600">
                    {{ $t('new-connection-cmh.address-step.oneInterlocutorThroughoutTheProcessEmphasis') }}
                  </span>
                </i18n>
                <i18n class="main-title-modal text" path="new-connection-cmh.address-step.allYourConnectionInOneDay"
                  scope="global" tag="p">
                  <span class="lib__text-weight-600">
                    {{ $t('new-connection-cmh.address-step.allYourConnectionInOneDayEmphasis') }}
                  </span>
                </i18n>
                <i18n class="main-title-modal text"
                  path="new-connection-cmh.address-step.vooAndProximusConnectionsFreeWithoutSubcription" scope="global"
                  tag="p">
                  <span class="lib__text-weight-600">
                    {{ $t('new-connection-cmh.address-step.vooAndProximusConnectionsFreeWithoutSubcriptionEmphasis') }}
                  </span>
                </i18n>
              </template>
            </cmh-modal-partners>

          </ModalDialog>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import Step from '@/components/steps/Step'
import Component from 'vue-class-component'
import { SubCity, StreetSubCity, MapLocation, NewConnectionRequestAddress } from '@/models'
import { State, Mutation } from 'vuex-class'
import StreetSubCitySelector from '@/components/inputs/Address/StreetSubCitySelector.vue'
import AvailableServiceDisplay from '@/components/display/AvailableServiceDisplay.vue'
import { CmhAddressPoint } from '@/models/cmh-address-point'
import BuildingTypeSelector from '@/components/inputs/Address/BuildingTypeSelector.vue'
import { helper } from '@/services'
import ConnectionPointArea from '@/components/inputs/Address/ConnectionPointArea.vue'
import MapLocationPicker from '@/components/inputs/Address/MapLocationPicker.vue'
import { BuildingType } from '@/models/building-type'
import CmhProvidersExternalLinks from '@/components/display/CmhProvidersExternalLinks.vue'
import CmhModalPartners from '@/components/steps/new-connection-cmh/modal/CmhModalPartners.vue'
import ZipCodeLocalitySelector from '@/components/inputs/Address/ZipCodeLocalitySelector.vue'
import { Watch } from 'vue-property-decorator'
import { pixelFacebookService } from '@ores/vue-library'

@Component({
  components: {
    CmhModalPartners,
    CmhProvidersExternalLinks,
    StreetSubCitySelector,
    BuildingTypeSelector,
    AvailableServiceDisplay,
    ConnectionPointArea,
    MapLocationPicker,
    ZipCodeLocalitySelector
  },
  name: 'cmh-address-step'
})
export default class CmhAddressStep extends Step {
  //#region [Data]
  @State('subCity', { namespace: 'newConnectionCmh/landingPage' })
  public stateSubCity!: SubCity

  @State('packageFromSimulator', { namespace: 'newConnectionCmh/landingPage' })
  public statePackageFromSimulator!: string | null

  @State('addressPoint', { namespace: 'newConnectionCmh/cmhAddress' })
  public stateAddressPoint!: CmhAddressPoint

  @State('requestId', { namespace: 'newConnectionCmh' })
  public requestId!: string

  public subCity: SubCity | null = null
  public streetSubCity: StreetSubCity | null = null
  public mapLocation: MapLocation | null = null
  public houseNumber: string | null = null
  public selection: BuildingType = BuildingType.unknown
  public flatNumber: number | null = null
  public commonElectricMeterNumber: number | null = null

  public addMapLocation: boolean = false
  public isNonFinalHouseNumber: boolean = false
  public isStreetSubCityValid: boolean = false
  public isBuildingInfoModalOpen: boolean = false
  public isNonFinalNumberModalOpen: boolean = false

  public hasOres: boolean = false

  //#endregion

  //region [Mutation]
  @Mutation('STORE', { namespace: 'newConnectionCmh/cmhAddress' })
  public store!: (index: CmhAddressPoint) => void

  @Mutation('STORE', { namespace: 'newConnectionCmh/landingPage' })
  private subCityStore!: (index: SubCity | null) => void

  @Mutation('CLEAR', { namespace: 'newConnectionCmh/cmhEnergyConfiguration' })
  private clearEnergyConfiguration!: () => void
  //endregion

  //#region [Method]
  public mounted(): void {
    pixelFacebookService.trackViewContent({
      content_ids: ['CmhForm'],
      content_name: 'Address Step',
      content_type: 'product'
    })
    this.subCity = helper.clone(this.stateSubCity)
    if (this.stateAddressPoint?.addressPoint ?? false) {
      if (this.stateAddressPoint?.addressPoint?.streetSubCity ?? false) {
        this.streetSubCity = helper.clone(this.stateAddressPoint?.addressPoint?.streetSubCity) || null
      }
      if (this.stateAddressPoint?.addressPoint?.mapLocation ?? false) {
        this.mapLocation = helper.clone(this.stateAddressPoint?.addressPoint?.mapLocation) || null
      }
      if (this.stateAddressPoint?.addressPoint?.isMapLocation ?? false) {
        this.addMapLocation = helper.clone(this.stateAddressPoint?.addressPoint?.isMapLocation) || false
      }
      if (this.stateAddressPoint?.selection !== BuildingType.unknown) {
        this.selection = helper.clone(this.stateAddressPoint.selection)
      }
    }
    this.houseNumber = this.stateAddressPoint?.addressPoint?.houseNumber ?? null
    this.flatNumber = this.stateAddressPoint?.flatNumber ?? null
    this.commonElectricMeterNumber = this.stateAddressPoint?.commonElectricMeterNumber ?? null
    if (this.statePackageFromSimulator !== null) {
      this.onSelectionChange(BuildingType.house);
    }
  }

  public onStreetSubCityValidation(isValid: boolean): void {
    this.isStreetSubCityValid = isValid
    if (!isValid && this.houseNumber != null) {
      this.houseNumber = null
    }
  }

  public onSelectionChange(value: BuildingType): void {
    this.selection = value
    this.clearEnergyConfiguration()
  }

  public async save(next: boolean, isValid: boolean): Promise<boolean | void> {
    if (isValid) {
      if (
        this.hasOres &&
        (this.isHouseSelected || (this.isBuildingSelected && this.flatNumber && this.commonElectricMeterNumber))
      ) {
        this.store({
          addressPoint: {
            subCity: this.subCityOrState,
            streetSubCity: this.streetSubCity,
            houseNumber: this.houseNumber,
            isMapLocation: this.addMapLocation,
            isNonFinalHouseNumber: this.isNonFinalHouseNumber,
            mapLocation: this.mapLocation
          },
          selection: this.selection,
          flatNumber: this.flatNumber,
          commonElectricMeterNumber: this.commonElectricMeterNumber
        })

        await this.saveStep()

        this.$appInsights.trackEvent('WR_NCCMH_Step1_Validated', {
          Segment: 'WR_NCCMH',
          WebRef: this.requestId,
          Address: this.fullAddressString,
          IsMapLocation: this.addMapLocation.toString(),
          IsNonFinalHouseNumber: this.isNonFinalHouseNumber.toString(),
          PostCode: this.subCityOrState.zipCode,
          IsCmhAvailable: this.isAvailable.toString(),
          IsCmhFullyAvailable: this.isFullyAvailable.toString()
        })
        return true
      } else {
        return false
      }
    }
  }

  public async saveStep() {
    const data: NewConnectionRequestAddress = {
      zipCode: this.subCityOrState ? this.subCityOrState.zipCode : null,
      subCityId: this.subCityOrState ? this.subCityOrState.georesSubcityId : null,
      streetSubCityId: this.streetSubCity ? this.streetSubCity.georesStreetSubcityId : null,
      houseNumber: this.houseNumber ?? null,
      isNonFinalHouseNumber: this.isNonFinalHouseNumber,
      isMapLocation: this.addMapLocation,
      latitude: this.mapLocation?.lat ?? null,
      longitude: this.mapLocation?.lng ?? null,
      buildingType: this.selection,
      flatNumber: this.flatNumber,
      commonElectricMeterNumber: this.commonElectricMeterNumber
    }

    await this.$api.post<NewConnectionRequestAddress>(`NewConnectionRequest/store/${this.requestId}/address`, data)
  }

  public openBuildingInfoModal(): void {
    this.isBuildingInfoModalOpen = true
  }

  public openNonFinalNumberModal(): void {
    this.isNonFinalNumberModalOpen = true
  }

  @Watch('subCity')
  public onSubCityChanged() {
    this.subCityStore(this.subCity)
  }
  //#endregion

  //#region [Computed]
  public get isBuildingSelected(): boolean {
    return this.selection.valueOf() === BuildingType.building.valueOf()
  }

  public get hasBuildingCmhUnavailable(): boolean {
    return (
      this.isBuildingSelected && !!this.flatNumber && (this.flatNumber > 4 || (this.commonElectricMeterNumber ?? 0) > 1)
    )
  }

  public get isHouseSelected(): boolean {
    return this.selection.valueOf() === BuildingType.house.valueOf()
  }

  public getCmhLogoStyle(): { filter: 'invert(100%) brightness(100%) contrast(0%)' | '' } {
    return this.hasBuildingCmhUnavailable ? { filter: 'invert(100%) brightness(100%) contrast(0%)' } : { filter: '' }
  }

  public get isAvailable(): boolean {
    if (this.subCity) {
      return this.subCity.connectMyHomeActivated && !!this.subCity.connectMyHomeInformation
    }

    return true
  }

  public get isFullyAvailable(): boolean {
    if (this.subCity?.connectMyHomeInformation !== null) {
      return (
        this.isAvailable &&
        !!this.subCity?.connectMyHomeInformation?.proximusAvailable &&
        !!this.subCity?.connectMyHomeInformation?.vooAvailable &&
        !!this.subCity?.connectMyHomeInformation?.swdeAvailable
      )
    }
    return false
  }

  public get currentWindowWidth() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }

  public get areLinksDisplayed() {
    return (
      (this.isHouseSelected && !this.isFullyAvailable) ||
      (this.hasBuildingCmhUnavailable && this.flatNumber && this.commonElectricMeterNumber) ||
      (!this.hasBuildingCmhUnavailable && !this.isFullyAvailable && this.flatNumber && this.commonElectricMeterNumber)
    )
  }

  public get areAvailableServiceDisplayed() {
    return (
      this.isHouseSelected || (this.flatNumber && this.commonElectricMeterNumber && !this.hasBuildingCmhUnavailable)
    )
  }

  public get isSelectionStepDisplayed() {
    return (
      (this.houseNumber && !!this.streetSubCity && this.isStreetSubCityValid) ||
      (this.addMapLocation && this.mapLocation && this.isStreetSubCityValid)
    )
  }

  public get addressString(): string | null {
    return this.subCity ? `${this.subCity.zipCode} ${this.subCity.cityName}, Belgique` : null
  }

  public get fullAddressString(): string {
    if (this.addMapLocation) {
      return `${this.subCityOrState.zipCode} ${this.subCityOrState.cityName}, http://maps.google.com/maps?q='${this.mapLocation!.lat
        };${this.mapLocation!.lng}`
    }
    return `${this.houseNumber} ${this.streetSubCity!.name}, ${this.subCityOrState.zipCode} ${this.subCityOrState.cityName
      }`
  }

  public get subCityOrState(): SubCity {
    return this.subCity ?? this.stateSubCity
  }
  //#endregion
}
</script>

<style scoped>
.logos {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  place-content: center;
  gap: 0.8rem
}

.logos>* {
  position: static;
  max-height: 100px;
  min-height: 50px;
}

@media screen and (min-width: 577px) {
  .main-title-modal.text {
    font-size: 17px;
    margin: 20px auto;
    width: 500px;
  }

  .main-title-modal.logos {
    width: 400px;
    height: 100px;
    margin: 0 auto 10px;
  }

  .cmh-logo {
    height: 76px;
    width: 229px;
    display: block;
    margin: 40px auto auto;
  }

  .cmh-availability-top-paragraph {
    height: 72px;
    width: 500px;
    margin: 28px auto 0;
  }

  .cmh-availability-middle-paragraph {
    height: 40px;
    width: 600px;
    font-size: 16px;
    margin: 0 auto auto;
  }

  .cmh-availability-middle-paragraph.building-text {
    margin-top: 30px;
    width: 700px;
  }

  .available-service-container {
    width: 560px;
    margin: auto;
  }

  .cmh-availability-bottom-paragraph {
    width: 700px;
    font-size: 16px;
    margin: 20px auto;
  }
}

@media screen and (max-width: 576px) {
  .cmh-availability-top-paragraph-icon-info {
    font-size: 14px;
  }


  .main-title-modal.text {
    font-size: 15px;
    margin: 20px auto;
  }

  .main-title-modal.logos {
    width: 260px;
    height: 70px;
  }

  .cmh-availability-bottom-paragraph {
    width: 90%;
    font-size: 15px;
    margin: 20px auto;
  }

  .cmh-availability-top-paragraph {
    width: 90%;
    margin: 20px auto;
  }

  .cmh-availability-middle-paragraph {
    height: 40px;
    width: 280px;
    font-size: 15px;
    margin: 0 auto auto;
  }

  .available-service-container {
    margin: 20px auto;
    width: 305px;
  }

  .cmh-logo {
    height: 53px;
    width: 163px;
    display: block;
    margin: 40px auto 0;
  }
}
</style>
